module.exports = __webpack_public_path__ + "static/img/manage-bg.845208b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/manage-bg.png
// module id = w6X2
// module chunks = 0